const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M17.5 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="M13.25 12.707v8.043H16a.75.75 0 0 0 0-1.5h-1.25V4.75H16a.75.75 0 0 0 0-1.5h-2.75v8.043a.8.8 0 0 0-.25-.043H4a.75.75 0 0 0 0 1.5h9a.8.8 0 0 0 .25-.043M20.5 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/></svg>';
export {
  a as w
};
